/**
 * KAILAS Size Chart Enhanced Interactions
 * Provides accordion functionality and smooth animations
 */

(function() {
  'use strict';

  // Initialize size chart functionality
  function initSizeChart() {
    const sizeChartContainer = document.querySelector('.size-chart-container');
    if (!sizeChartContainer) return;

    // Accordion toggle functionality
    const sectionHeaders = document.querySelectorAll('.size-section-header');
    
    sectionHeaders.forEach(header => {
      header.addEventListener('click', function(e) {
        e.preventDefault();
        const section = this.closest('.size-section');
        const allSections = document.querySelectorAll('.size-section');
        
        // Toggle current section
        section.classList.toggle('active');
        
        // Optional: Close other sections (uncomment for single-open behavior)
        // allSections.forEach(s => {
        //   if (s !== section) {
        //     s.classList.remove('active'); 
        //   }
        // });
      });
    });

    // Add keyboard accessibility
    sectionHeaders.forEach(header => {
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      
      header.addEventListener('keypress', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Add ARIA attributes for accessibility
    const sections = document.querySelectorAll('.size-section');
    sections.forEach((section, index) => {
      const header = section.querySelector('.size-section-header');
      const content = section.querySelector('.size-section-content');
      
      const headerId = `size-section-header-${index}`;
      const contentId = `size-section-content-${index}`;
      
      header.setAttribute('id', headerId);
      header.setAttribute('aria-controls', contentId);
      
      content.setAttribute('id', contentId);
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', headerId);
      
      // Update aria-expanded based on active state
      updateAriaExpanded(section);
    });

    // Update ARIA expanded state
    function updateAriaExpanded(section) {
      const header = section.querySelector('.size-section-header');
      const isActive = section.classList.contains('active');
      header.setAttribute('aria-expanded', isActive.toString());
    }

    // Observe class changes to update ARIA
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const section = mutation.target;
          updateAriaExpanded(section);
        }
      });
    });

    sections.forEach(section => {
      observer.observe(section, { attributes: true });
    });

    // Smooth scroll to section if hash in URL
    const hash = window.location.hash;
    if (hash) {
      const targetSection = document.querySelector(hash);
      if (targetSection && targetSection.classList.contains('size-section')) {
        setTimeout(() => {
          targetSection.classList.add('active');
          targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }

    // Table responsive enhancement
    enhanceTableResponsiveness();

    // Add print functionality
    // addPrintButton();
  }

  // Enhance table responsiveness
  function enhanceTableResponsiveness() {
    const tables = document.querySelectorAll('.size-table');
    
    tables.forEach(table => {
      // Add touch scroll hint for mobile
      const wrapper = table.closest('.size-table-wrapper');
      if (wrapper && isMobileDevice()) {
        wrapper.style.cursor = 'grab';
        
        let isScrolling = false;
        wrapper.addEventListener('touchstart', () => {
          isScrolling = true;
          wrapper.style.cursor = 'grabbing';
        });
        
        wrapper.addEventListener('touchend', () => {
          isScrolling = false;
          wrapper.style.cursor = 'grab';
        });
      }
    });
  }

  // Check if device is mobile
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  // Add print functionality
  function addPrintButton() {
    const header = document.querySelector('.size-chart-header');
    if (!header) return;

    const printBtn = document.createElement('button');
    printBtn.className = 'size-chart-print-btn';
    printBtn.innerHTML = '🖨️ Print Size Guide';
    printBtn.style.cssText = `
      margin: 20px auto;
      padding: 12px 24px;
      background: #2c3e50;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: background 0.3s ease;
      display: block;
    `;

    printBtn.addEventListener('mouseenter', () => {
      printBtn.style.background = '#34495e';
    });

    printBtn.addEventListener('mouseleave', () => {
      printBtn.style.background = '#2c3e50';
    });

    printBtn.addEventListener('click', () => {
      // Open all sections before printing
      document.querySelectorAll('.size-section').forEach(section => {
        section.classList.add('active');
      });

      setTimeout(() => {
        window.print();
      }, 300);
    });

    header.appendChild(printBtn);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChart);
  } else {
    initSizeChart();
  }

  // Re-initialize for AJAX-loaded content (Shopify theme extensions)
  document.addEventListener('shopify:section:load', initSizeChart);
})();
